import script from "./CustomerSharing.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomerSharing.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__